/** @format */
import { useEffect, useState } from 'react';

export function useSessionStorage<T>(key: string, initialValue: T) {
    /*
     * State to store our value
     * Pass initial state function to useState so logic is only executed once
     */
    const [storedValue, setStoredValue] = useState(initialValue);

    useEffect(() => {
        try {
            // Get from session storage by key
            const value = window.sessionStorage.getItem(key);
            if (value) {
                // Parse stored json or if none return initialValue
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- Legacy code: do not use as an example.
                setStoredValue(JSON.parse(value));
            }
        } catch (error) {
            console.error(error);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, []);

    useEffect(() => {
        window.sessionStorage.setItem(key, JSON.stringify(storedValue));
        // eslint-disable-next-line react-hooks/exhaustive-deps -- Legacy code: do not use as an example.
    }, [storedValue]);

    return [storedValue, setStoredValue] as const;
}
